import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import {Tools} from './Tools';
import {Inc,Dataset,FavSearchCondition} from './Inc';
import Title from './Title';
import AppBank from './AppBank';

interface FavListSearchProps {
    update(cond:FavSearchCondition,page:number): void,
	bankKey:string,
	bank:AppBank,	
}

const FavListSearch = (props:FavListSearchProps)=> {
    const classes = useStyles();
    const [states,setStates] = useState(Inc.defaultFavSearchCondition());

    const update = ()=>{
		props.bank.set(props.bankKey,JSON.stringify(states));
        props.update(states,1);
    }
	const handleChange = (name: keyof FavSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeNumber = (name: keyof FavSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setStates({ ...states, [name]: Tools.toHan(event.target.value as string) });
		//setStates({ ...states, [name]: event.target.value as string });
        //setStates({ ...states, [name]: event.target.value });
	};
    
	const handleChangeSelect = (name: keyof FavSearchCondition) => (event: SelectChangeEvent) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const resetCondition = ()=>{
		setStates(Inc.defaultFavSearchCondition());
	}
   
    useEffect( ()=>{
		if( props.bank.has(props.bankKey) ){
			//console.log("load");
			const cond = JSON.parse(props.bank.get(props.bankKey));
			setStates(cond);
			props.update(cond,1);
		} else {
			props.update(states,1);
		}
    },[])
    
    const years = Tools.getSelectYears();
    const months = Tools.getSelectMonths();

    let error = false;
    if( states.item_id!=="" && !Tools.isNumber(states.item_id) ){
        error = true;
    }
    
	return (
		<div id="fav_list_search">
            
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Title text="検索条件" size={2}/>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.searchButtons}>
                        <Button variant="outlined" color="primary" onClick={update} disabled={error}><SearchIcon/>検索</Button>
                    </div>
                </Grid>
                <Grid item xs={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>商品名</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.item_name}
							variant='standard'
                            onChange={handleChange("item_name")}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>商品ID</FormLabel>
                        <TextField
                            className={classes.input}
                            inputProps={{
                                'aria-label': 'Description',
                            }}
                            margin="none"
                            value={states.item_id}
							variant='standard'
                            onChange={handleChangeNumber("item_id")}
                        />
                        {error &&
                        <FormHelperText>数字で入力して下さい</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>スキの種類</FormLabel>
                        <Select
                            value={states.type_id}
                            onChange={handleChangeSelect('type_id')}
                            inputProps={{
                                name: 'type_id',
                                id: 'type_id-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            <MenuItem key="page_id0" value="">　</MenuItem>
                            {Inc.favTypes.map((option:Dataset,index:number) => {
                                const key = "type_id"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                    <FormGroup row>
                        <FormControl className={classes.formControl} >
                            <FormLabel component="label" className={classes.formLabel}>月日</FormLabel>
                            
                            <Select
                                value={states.date_year}
                                onChange={handleChangeSelect('date_year')}
                                inputProps={{
                                    name: 'year',
                                    id: 'year-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'7em'}}
                            >
                                <MenuItem key="year0" value="">　</MenuItem>
                                {years.map((option:Dataset,index:number) => {
                                    const key = "year"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>

                        <FormControl className={classes.formControl}>
                            <FormLabel component="label" className={classes.formLabel}>　</FormLabel>
                            <Select
                                value={states.date_month}
                                onChange={handleChangeSelect('date_month')}
                                inputProps={{
                                    name: 'month',
                                    id: 'month-simple',
                                }}
                                margin="none"
								variant='standard'
                                className={classes.select}
								style={{width:'5em'}}
                            >
                                <MenuItem key="month0" value="">　</MenuItem>
                                {months.map((option:Dataset,index:number) => {
                                    const key = "month"+index;
                                    return (
                                        <MenuItem key={key} value={option.id}>
                                            {option.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </FormGroup>
                </Grid>

            </Grid>
            <Button variant="outlined" fullWidth={true} className={classes.buttonReset} onClick={resetCondition}><DeleteIcon/>検索条件のリセット</Button>
		</div>
	);
}

export default FavListSearch;
